module.exports = __webpack_public_path__ + "static/media/Gold_Badge.63a0a235.zip";